module.exports = __webpack_public_path__ + "static/img/1.c54a2b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/3/zh/1.png
// module id = 6KEk
// module chunks = 0